module.exports = __webpack_public_path__ + "assets/img/2_809_big.43d05c14.jpg";